import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';

import Iconify from '../../../../components/Iconify';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';

export const AccommodationPrefixDialog = props => {
  const { open, setOpen, node } = props;
  const { updateNodeF, changedPrefixes, setChangedPrefixes } = useAccomodationDiagram();
  const [prefix, setPrefix] = React.useState(node?.data?.order?.accommodation_prefix || '');

  const onSubmit = () => {
    const newNode = node;
    newNode.data = {
      ...newNode.data,
      order: { ...newNode.data.order, accommodation_prefix: prefix }
    };
    updateNodeF(newNode);
    const newPrefixes = changedPrefixes;
    newPrefixes[node.data.order.identifier] = prefix;
    setChangedPrefixes(newPrefixes);

    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Prefix</Typography>
          <TextField
            sx={{ flex: '1 1 80%' }}
            type="text"
            placeholder="prefix"
            value={prefix}
            onChange={e => setPrefix(e.target.value)}
            autoFocus
            multiline
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
